import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import currencyUnformatted from "currency.js";
import ControlHubContext from "../../contexts/controlhub";
import getAPI from "./api";

const useControlHub = () => {
  const { configuration, currentCompanyId, currentUserId, cookieSession } =
    useContext(ControlHubContext);
  const [api, setApi] = useState(getAPI({}));
  const [company, setCompany] = useState({
    features: {
      sendToAPInbox: false,
      apInboxName: "",
      billPayments: false,
      fileMimeTypes: [],
      fileMaxSize: 0,
      invoiceTolerance: 0,
    },
  });
  const [user, setUser] = useState({
    id: "",
    company: "",
  });

  useEffect(() => {
    if (!currentCompanyId || !cookieSession) {
      return;
    }
    setApi(getAPI({ companyID: currentCompanyId, cookieSession }));
  }, [currentCompanyId, cookieSession]);

  useEffect(() => {
    if (!configuration) {
      return;
    }
    setCompany({
      features: {
        sendToAPInbox:
          "send_to_accounts_payable_inbox" in configuration
            ? configuration["send_to_accounts_payable_inbox"]
            : false,
        apInboxName:
          "accounts_payable_system_name" in configuration
            ? configuration["accounts_payable_system_name"]
            : "AP System",
        billPayments:
          "bill_payments" in configuration
            ? configuration["bill_payments"]
            : false,
        fileMimeTypes:
          "file_mime_types" in configuration
            ? configuration["file_mime_types"]
            : ["image/jpg", "image/jpeg", "image/png", "application/pdf"],
        fileMaxSize:
          "file_size" in configuration ? configuration["file_size"] : 5000000,
        invoiceTolerance:
          "invoice_percent_tolerance" in configuration
            ? configuration["invoice_percent_tolerance"]
            : 0,
      },
    });
  }, [configuration]);

  useEffect(() => {
    setUser({
      id: currentUserId,
      company: currentCompanyId,
    });
  }, [currentCompanyId, currentUserId]);

  const currency = useCallback(
    (cents) => {
      if (configuration && "comma_dot_order" in configuration) {
        return currencyUnformatted(cents, {
          errorOnInvalid: true,
          fromCents: true,
          decimal: configuration["comma_dot_order"] ? "." : ",",
          separator: configuration["comma_dot_order"] ? "," : ".",
        });
      } else {
        return currencyUnformatted(cents, { fromCents: true });
      }
    },
    [configuration]
  );

  const hook = useMemo(
    () => ({ api, company, user, currency }),
    [api, company, currency, user]
  );

  return hook;
};

export default useControlHub;
